import {
  BaseFile,
  FileUploaderV2RefType,
} from '@mint-lib/tw-components/patterns';
import type { MediaPlan } from '@mint-sdk/api-media-plan';

import { ImportPlanViews } from '../../../../../../../types/import.types.js';
import { FileUploadErrorView } from './FileUploadErrorView.jsx';
import { FileUploadView } from './FileUploadView.jsx';
import { FileValidationView } from './FileValidationView.jsx';

export type CommonPropsType = {
  fileUploaderRef: React.RefObject<FileUploaderV2RefType | null>;
  setFiles: React.Dispatch<React.SetStateAction<BaseFile[]>>;
  handleFileUpload: (fileBlob: File) => Promise<unknown>;
  activities: MediaPlan.SidebarItem[];
  selectedActivityId: string | undefined;
  onActivityChange: (activityId: string) => void;
};

const mapStatusToView = {
  [ImportPlanViews.ERROR]: FileUploadErrorView,
  [ImportPlanViews.PENDING]: FileValidationView,
  [ImportPlanViews.UPLOAD]: FileUploadView,
};

const ModalViewFactory = ({
  activeView,
  props,
}: {
  activeView: ImportPlanViews;
  props: CommonPropsType;
}) => {
  const CurrentView = mapStatusToView[activeView];

  return <CurrentView {...props} />;
};

export default ModalViewFactory;
